// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.externaldata.ExternalDataListResponse */
/* istanbul ignore next */
@GandalfModel
export class ExternalDataListResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	externalDataId!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	requestDate!: Date | null;

	@GandalfConstantDecorator(constants.ExternalDataStatus)
	@GandalfProperty({ designType: constants.ExternalDataStatus })
	status!: constants.ExternalDataStatus | null;

}
